import { ethers } from "ethers";
import ErrorHandler from "../Helpers/ErrorHandler.jsx";
import { notifications } from "../Helpers/Notifications";
export default class MetaMaskService {
  constructor() {}

  componentDidMount() {
    if (window.ethereum) {
      // window.ethereum.on("accountsChanged", accountsChanged);
      // window.ethereum.on("chainChanged", chainChanged);
    }
  }

  connect = async () => {
    if (window.ethereum) {
      try {
        const res = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        return res[0];
      } catch (err) {
        new ErrorHandler().processEtherMessage(err);
      }
    } else {
      notifications.error("Install metamask extension!!");
    }
  };

  isMetaMaskConnected = async () => {
    if (window.ethereum && window.ethereum.isMetaMask) {
      var provider = new ethers.providers.Web3Provider(window.ethereum);

      const accounts = await provider.listAccounts();
      return accounts.length > 0;
    }
  };

  getAccount = async () => {
    if (window.ethereum && window.ethereum.isMetaMask) {
      var provider = new ethers.providers.Web3Provider(window.ethereum);

      const accounts = await provider.listAccounts();
      return accounts.length > 0 ? accounts[0] : null;
    }

    return null;
  };
 
  logoutUser = async() => {
   // await web3Modal.clearCachedProvider()
    // if (window.ethereum && window.ethereum.isMetaMask) {
    //     window.ethereum.on('accountsChanged', function (accounts) {
    //         return () => window.ethereum.removeListener('accountsChanged', accounts);
    //     });    
    // }
  }
}
